export const SET_PAGE = 'SET_PAGE';
export const SET_FIRST_VISIT = 'CHECK_FIRST_VISIT';
export const SET_FAVOURITES = 'SET_FAVOURITES';
export const SET_COIN_LIST = 'SET_COIN_LIST';
export const SET_FILTER = 'SET_FILTER';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const SET_FILTER_TEXT = 'SET_FLITER_TEXT';
export const SET_CURRENT = 'SET_CURRENT';
export const DELETE_CURRENT = 'DELETE_CURRENT';
export const SET_PRICES = 'FETCH_PRICES';
export const SET_CURRENT_FROM_LOCAL_STORAGE = 'SET_CURRENT_FROM_LOCAL_STORAGE';
export const SET_SPOTLIGHT = 'SET_SPOTLIGHT';
export const SET_DASHBOARD_CURRENT = 'SET_DASHBOARD_CURRENT';
export const DELETE_DASHBOARD_CURRENT = 'DELETE_DASHBOARD_CURRENT';
export const SET_DASHBOARD_CURRENT_FROM_LOCAL_STORAGE =
  'SET_DASHBOARD_CURRENT_FROM_LOCAL_STORAGE';
export const DELETE_DASHBOARD_CURRENT_FROM_LOCAL_STORAGE =
  'DELETE_DASHBOARD_CURRENT_FROM_LOCAL_STORAGE';
export const SET_DASHBOARD_FAVOURITES = 'SET_DASHBOARD_FAVOURITES';
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const GET_HISTORY_DATA = 'GET_HISTORY_DATA';
export const DELETE_COIN_PRICE_HISTORY = 'DELETE_COIN_PRICE_HISTORY';
export const SET_COIN_PRICE_HISTORY_FROM_LOCAL_STORAGE =
  'SET_COIN_PRICE_HISTORY_FROM_LOCAL_STORAGE';
export const SET_SERIES = 'SET_SERIES';
